import { createAppStore } from '@marriott/mi-store-utils';
import { StateCreator } from 'zustand';

import { SecondaryNavigationProps, ActiveMenuItem } from '../organisms/SecondaryNavigation/SecondaryNavigation.types';

export type SecondaryNavigationData = {
  model: SecondaryNavigationProps['model'] | null;
  activeMenuItem?: ActiveMenuItem;
};

type SecondaryNavigationState = {
  secondaryNavigationData: SecondaryNavigationData | null;
};

type SecondaryNavigationActions = {
  setSecondaryNavigationData: (data: SecondaryNavigationData) => void;
  clearSecondaryNavigationData: () => void;
};

const initialState: SecondaryNavigationState = {
  secondaryNavigationData: null,
};

export const secondaryNavigationStore: StateCreator<SecondaryNavigationState & SecondaryNavigationActions> = set => {
  return {
    ...initialState,

    setSecondaryNavigationData: (data: SecondaryNavigationData) => {
      set({ secondaryNavigationData: data });
    },

    clearSecondaryNavigationData: () => {
      set({ secondaryNavigationData: null });
    },
  };
};

export const useSecondaryNavigationStore = createAppStore(secondaryNavigationStore);
